import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@fikasio/react-ui-components';
import { listTimeZones, timeZoneLabel } from 'utils/timezone';

interface TimeZoneSelectorProps {
  onChange: (timeZone: string) => void;
  value: string;
}

const TimeZoneSelector = ({
  onChange,
  value,
}: TimeZoneSelectorProps) => {
  const { t } = useTranslation();

  const options = useMemo(() => {
    const zones = listTimeZones();
    const values = value && !zones.includes(value) ? [value, ...zones] : zones;
    return [
      { label: t('timeZoneDevice'), value: '' },
      ...values.map(zone => ({ label: timeZoneLabel(zone), value: zone })),
    ];
  }, [t, value]);

  return (
    <Select
      onChange={onChange}
      options={options}
      style={{ maxWidth: 420 }}
      value={value}
    />
  );
};

export default TimeZoneSelector;
